export enum MilitaryDraftAuthorizations {
  LevaEx = 'OP_LEVA',
  ClassiLeva = 'OP_LEVA',
  ClassiLevaQuery = 'OP_LEVA',
  ClassiLevaDelete = 'OP_LEVA',
  ClassiLevaUpdate = 'OP_LEVA',
  ClassiLevaAdd = 'OP_LEVA',
}

export const MilitaryDraftExecute = [MilitaryDraftAuthorizations.LevaEx];
export const MilitaryDraftClassAuthorizations = [MilitaryDraftAuthorizations.ClassiLeva];

export const MilitaryDraftAuthorizationsList = [
  ...MilitaryDraftExecute,
  ...MilitaryDraftClassAuthorizations,
];
